import { ProductSimpleSearch } from './ProductSimpleSearch';

export default ProductSimpleSearch;